module.exports = __webpack_public_path__ + "img/ob_logo.c25e3db8.png";